import $ from 'jquery'

// Like data-toggle-prefix, but keyed on whether an input has a value (vs. its value).
//   <input data-toggle-presence="foo"> shows `.foo-present` / hides `.foo-absent` when filled,
//   and vice versa. Works with free-text inputs, and with an object picker through
//   `wrapper_attrs: { data: { toggle_presence: 'foo' } }` (its selection is data-selected-ids).

const togglePresenceSelector =
  'input[data-toggle-presence],textarea[data-toggle-presence],select[data-toggle-presence],[data-toggle-presence][data-selected-ids]'

$(document).on(
  'input.toggle-presence change.toggle-presence toggle-presence',
  togglePresenceSelector,
  function (e, data) {
    const $this = $(this)
    const value = this.matches('[data-selected-ids]')
      ? this.dataset.selectedIds
      : $this.val()
    const present = String(value ?? '').trim().length > 0
    const isAjaxUpdating = window.Simplero?.state?.isAjaxUpdating
    // Setting up newly inserted HTML (data.initial) snaps; only a person's change animates.
    const animate =
      ($this.data('toggle-presence-animate') ?? true) &&
      !isAjaxUpdating &&
      !data?.initial

    $this
      .data('toggle-presence')
      .split(' ')
      .forEach((p) => {
        const prefix = p.trim()
        if (!prefix) return

        const [toShow, toHide] = present
          ? [`.${prefix}-present`, `.${prefix}-absent`]
          : [`.${prefix}-absent`, `.${prefix}-present`]

        $(toHide).hideInputs(animate)
        if (window.js_dom_ready || !isAjaxUpdating)
          $(toShow).showInputs(animate)
      })
  }
)

if (window.onDomChanged) {
  window.onDomChanged(togglePresenceSelector, 1000, function () {
    return this.trigger('toggle-presence', { initial: true })
  })
} else {
  $(function () {
    $(togglePresenceSelector).trigger('toggle-presence')
  })
}
